import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className="max-w-xl mx-auto text-center py-16">
        <div className="w-16 h-16 rounded-full border border-[#FF3B30] flex items-center justify-center mx-auto mb-6">
          <XCircle size={32} className="text-[#FF3B30]" />
        </div>
        <div className="text-[#FF3B30] text-xs uppercase tracking-widest mb-2">Payment Cancelled</div>
        <h1 className="font-display text-4xl sm:text-5xl mb-4">NO ENTRY SUBMITTED</h1>
        <p className="text-white/50 mb-8">Your picks weren&apos;t saved. You can retry any time before lock.</p>
        <button
          onClick={() => navigate("/lobby")}
          data-testid="cancel-back-lobby"
          className="bg-[#00FF66] hover:bg-[#00e65b] text-black font-bold uppercase tracking-widest px-5 py-2.5 text-sm rounded-sm"
        >
          Back to Lobby
        </button>
      </div>
    </Layout>
  );
}
